import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SyncMapsService } from '../../../services/sync-maps/sync-maps.service';
import { SyncMap } from '../../../services/sync-maps/sync-maps.model';
import { debounce } from 'lodash';
import { Pagination, mockedData, getPaginationHeader } from 'src/app/utils/getPaginationHeader';
import { HttpErrorResponse } from '@angular/common/http';
import { MySnackBarService } from '../../../shared/snackbar/my-snackbar.service';
import { GridDataResult, PageChangeEvent, GridComponent, ExcelComponent } from '@progress/kendo-angular-grid';
import { SortDescriptor, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ColumnSettings } from '../../../../app/utils/column-settings.interface';
import { StorageService } from '../../../../app/utils/StorageHelper';
import { SideNavService } from '../../../services/side-nav/sidenav.service';
import { emptyLookup, Lookup } from 'src/app/services/lookups/lookups.model';
import { LookupsService } from '../../../services/lookups/lookups.service';
import { SyncMapSingleComponent } from '../sync-map-single/sync-map-single.component';
import { NotificationHelper } from '../../../utils/NotificationHelper';
import { DeleteConfirmationComponent } from '../../../shared/delete-confirmation/delete-confirmation.component';
//import { PriceBookService } from '../../../services/price-book/price-book.service';
//import { PriceBook, emptyPriceBook } from '../../../services/price-book/price-book.model';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { SyncSetEntity } from '../../../services/sync-set-entities/sync-set-entities.model';
import { CopyService } from '../../../services/copy/copy.service';
import { ExportConfirmationComponent } from 'src/app/shared/export-confirmation/export-confirmation.component';
import { ImportsService } from '../../../services/imports/imports.service';

@Component({
  selector: 'sync-map-list',
  templateUrl: './sync-map-list.component.html',
  styleUrls: ['./sync-map-list.component.scss'],
})
export class SyncMapListComponent implements AfterViewInit, OnInit {
  @ViewChild('grid') myGrid: GridComponent;
  @ViewChild('hiddenfileinput') fileUploader: ElementRef;

  runNowMenuItems = [
    { id: 1, text: 'Sync All Records' },
    { id: 2, text: 'Sync Test 5 Records' },
    { id: 3, text: 'Sync Created in Last 5 Minutes' },
    { id: 4, text: 'Sync Created in Last 30 Minutes' },
    { id: 5, text: 'Sync Modified in Last 5 Minutes' },
    { id: 6, text: 'Sync Modified in Last 30 Minutes' }
  ];

  constructor(
    private syncMapsService: SyncMapsService,
    //private priceBooksService: PriceBookService,
    private router: Router,
    private modalService: NgbModal,
    private utilitiesService: UtilitiesService,
    public activeModal: NgbActiveModal,
    private snack: MySnackBarService,
    private sideNavService: SideNavService,
    private lookupService: LookupsService,
    private notificationHelper: NotificationHelper,
    private importsService: ImportsService,
    private copyService: CopyService,
    private changeDetectorRef: ChangeDetectorRef  //used for ExpressionChangedAfterItHasBeenCheckedError
  ) {
    this.onFilterChange = debounce(this.onFilterChange, 300, { leading: true });
    this.allData = this.allData.bind(this);
  }

  @Input() loading: boolean = true;  //loading is a culprit in ExpressionChangedAfterItHasBeenCheckedError. setting to true here is correct.
  @Input() syncMaps: SyncMap[] = [];
  @Input() query = { PageSize: 25, SortTerm: 'name', PageNumber: 1, SearchTerm: '' };  //this does not have to be @input
  @Input() pagination: Pagination = mockedData;
  @Output() filterChange = new EventEmitter();
  @Output() onSelectSingle = new EventEmitter();
  @Input()
  mode: 'view' | 'lookup' = 'view';
  limits = [25, 50, 75, 100, 250];

  public mySelection: string[] = [];
  public gridView: GridDataResult;
  public pageSize = 25;
  public skip = 0;
  public filter: CompositeFilterDescriptor;
  public exportAll: boolean;
  public optDescColumns: boolean;
  public optRowID: boolean;
  public clickedRowItem;
  public gridClassName: string = "DefaultGrid";
  public queueTypeOptions: Lookup[];
  public entityTypeOptions: SyncSetEntity[];
  public queueStatusOptions: Lookup[];
  public filterable: boolean;
  public sort: SortDescriptor[] = [
    {
      field: 'Name',
      dir: 'asc',
    },
  ];
  defaultColumnsConfig: ColumnSettings[] = [
    {
      title: 'Name',
      field: 'name',
      width: 175,  //width is a culprit in ExpressionChangedAfterItHasBeenCheckedError. Set here, not in the html
      orderIndex: 0,
      hidden: false,
    },
    {
      title: 'Description',
      field: 'description',
      width: 175,
      orderIndex: 1,
      hidden: false,
    },
    {
      title: 'Sync Set',
      field: 'syncSet.name',
      width: 150,
      orderIndex: 2,
      hidden: false,
    },
    {
      title: 'Triggering Entity',
      field: 'triggeringEntity.name',
      width: 175,
      orderIndex: 3,
      hidden: false,
    },
    {
      title: 'Rank',
      field: 'rank',
      width: 50,
      orderIndex: 4,
      hidden: false,
    },
    {
      title: 'Active',
      field: 'isActive',
      width: 75,
      orderIndex: 5,
      hidden: false
    },
    {
      title: 'Sync Reader',
      field: 'syncReader.name',
      width: 175,
      orderIndex: 6,
      hidden: false,
    },
    {
      title: 'Sync Writer',
      field: 'syncWriter.name',
      width: 175,
      orderIndex: 7,
      hidden: false,
    },
    {
      title: 'Filter',
      field: 'filter',
      width: 175,
      orderIndex: 8,
      hidden: true,
    },
    {
      title: 'Single Record Filter',
      field: 'singleRecordFilter',
      width: 175,
      orderIndex: 9,
      hidden: true,
    },
    {
      title: 'Created On Filter',
      field: 'createdOnFilter',
      width: 175,
      orderIndex: 10,
      hidden: true,
    },
    {
      title: 'Modified On Filter',
      field: 'modifiedOnFilter',
      width: 175,
      orderIndex: 11,
      hidden: true,
    },
  ];
  columnsConfig: ColumnSettings[];

  ngOnInit(): void {
    //this.loading = true;  //loading is a culprit in ExpressionChangedAfterItHasBeenCheckedError. do not set here!
    this.query.PageSize = StorageService.PageSize() ?? 50;  //PageSize is a culprit in ExpressionChangedAfterItHasBeenCheckedError
    this.columnsConfig = this.defaultColumnsConfig.map(obj => ({ ...obj }));
    //this.loading = false; //loading is a culprit in ExpressionChangedAfterItHasBeenCheckedError. do not set here!
  }

  ngOnDestroy(): void {
    this.saveGrid();
  }

  async getQueueTypeOptions() {
    const Filter_OptionSet = 'QueueType';
    const PageSize = StorageService.PageSize() ?? 50;
    const params = { Filter_OptionSet, PageSize };
    this.queueTypeOptions = await this.lookupService.getList(params);
    const defaultLookup: Lookup = emptyLookup;
    defaultLookup.id = 999;
    defaultLookup.optionSet = "QueueType";
    defaultLookup.name = "(All)";
    this.queueTypeOptions.reverse();
    this.queueTypeOptions.push(defaultLookup);
    this.queueTypeOptions.reverse();
    return this.queueTypeOptions;
  }

  async getQueueStatusOptions() {
    const Filter_OptionSet = 'QueueStatus';
    const PageSize = StorageService.PageSize() ?? 50;
    const params = { Filter_OptionSet, PageSize };
    this.queueStatusOptions = await this.lookupService.getList(params);
    const defaultLookup: Lookup = emptyLookup;
    defaultLookup.id = 999;
    defaultLookup.optionSet = "QueueStatus";
    defaultLookup.name = "(All)";
    this.queueStatusOptions.reverse();
    this.queueStatusOptions.push(defaultLookup);
    this.queueStatusOptions.reverse();
    return this.queueStatusOptions;
  }

  onFilterClick() {
    this.filterable = !this.filterable;
  }

  async onClick_Delete() {
    const modalRef = this.modalService.open(DeleteConfirmationComponent);
    modalRef.componentInstance.confirmDelete.subscribe(() => {
      modalRef.close();
      this.DeleteRecords();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  async DeleteRecords() {
    const ids = [];
    this.mySelection.forEach((value) => {
      ids.push(Number(value));
    });

    await this.syncMapsService
      .removeByIds(ids)
      .then((showSuccess: VoidFunction) => {
        this.notificationHelper.showStatus('Record(s) deleted successfully!', 'success');
        this.mySelection = [];
      })
      .catch((err: HttpErrorResponse) => {
        this.notificationHelper.showStatus(err.error, "error");
      });

    this.loadListData();
  }

  async onClickCopy() {
    try {
      const ids = [];
      this.mySelection.forEach(async (value) => {
        const response: any = await this.copyService.performCopy(null, "RPMSyncMap", Number(value));
        const status: any = response.status;
        if (status === 200) {
          this.snack.openSnackBar(
            'Completed Copy successfully!' + response.body,
            '',
            false,
            'Success',
            'alert-success',
          );
          this.onRefresh();
        }
      });
    } catch (e) {
      this.snack.openSnackBar(e.error, '', true, 'Error', 'alert-danger');
    }
  }

  async onClick_Export(grid: GridComponent, excelComponent: ExcelComponent) {
    this.saveGrid();
    const modalRef = this.modalService.open(ExportConfirmationComponent);
    modalRef.componentInstance.gridRecordCount = this.gridView?.total;
    modalRef.componentInstance.siblingRecordCount = 0;  //no siblings
    modalRef.componentInstance.confirmExport.subscribe((options) => {
      modalRef.close();
      this.loading = true;
      console.log(options.optTechnicalStyle, options.optDescColumns, options.optRowID, options.optSiblingRecords);
      this.exportAll = options.optTechnicalStyle;
      this.optDescColumns = options.optDescColumns;
      this.optRowID = options.optRowID;
      if (options.optTechnicalStyle) {
        excelComponent.fetchData = this.allData;
      }
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.loading = false;
    });
  }

  async onFileChange(evt: any) {
    await this.importsService.onFileChange(evt, 'RPMSyncMap');
    this.fileUploader.nativeElement.value = null;
    this.loadListData();
  }

  public allData = (): Promise<any> => {
    this.query.PageSize = 200000;
    this.query.PageNumber = 1;
    this.loading = true;
    return this.syncMapsService.getExportList(this.query);
  };

  ConfigureGrid() {
    // Try and pull our grid configuration from the storage.
    let gridConfig: ColumnSettings[] = StorageService.getColumnSettings('SyncMapList_Config');

    // If it has not been persisted yet, then persist the default configuration
    if (!gridConfig) {
      StorageService.setColumnSettings('SyncMapList_Config', this.defaultColumnsConfig);
    } else {
      // Use the updated configuration for the user.
      this.columnsConfig = gridConfig;
    }

    // restore columns to saved configuration
    this.myGrid.columns.forEach(column => {
      const columnConfig = this.columnsConfig.find(cc => cc.title === column.title);

      if (columnConfig) {
        column.hidden = columnConfig.hidden;
        column.orderIndex = columnConfig.orderIndex;
        column.width = columnConfig.width;
      }
    });
  }

  saveGrid(): void {
    // save column configuration
    this.myGrid.columns.forEach(column => {
      const columnConfig = this.columnsConfig.find(cc => cc.title === column.title);

      if (columnConfig) {
        columnConfig.hidden = column.hidden;
        columnConfig.orderIndex = column.orderIndex;
        columnConfig.width = column.width;
      }
    });

    // sort the array, this is necessary for the excel export
    this.columnsConfig = this.columnsConfig.sort((cc1, cc2) => {
      if (cc1.orderIndex > cc2.orderIndex) {
        return 1;
      }

      if (cc1.orderIndex < cc2.orderIndex) {
        return -1;
      }

      return 0;
    });

    StorageService.setColumnSettings('SyncMapList_Config', this.columnsConfig);
  }

  ngAfterViewInit() {
    this.ConfigureGrid(); //culprit of ExpressionChangedAfterItHasBeenCheckedError, so use CDR on next line
    this.changeDetectorRef.detectChanges();  //solved width setting error for ExpressionChangedAfterItHasBeenCheckedError
    this.loadListData();
    this.getQueueTypeOptions();
    this.getQueueStatusOptions();

    this.sideNavService.sideNavChangedEvent.subscribe(
      (event) => {
        let SideNavExpanded_Config: boolean = StorageService.get('SideNavExpanded_Config');
        if (SideNavExpanded_Config == true) {
          this.gridClassName = "DefaultGrid"
        }
        else {
          this.gridClassName = "FullScreenGrid"
        }
      },
    );
  }

  onResetGridClick() {
    StorageService.removeColumnSettings('SyncMapList_Config');
    this.columnsConfig = this.defaultColumnsConfig.map(obj => ({ ...obj }));
    this.ConfigureGrid();
  }

  onFilterChange() {
    this.filterChange.emit(this.query);
    this.loadListData();
  }

  onRefresh() {
    this.loadListData();
  }

  onCellClick(e) {
    this.clickedRowItem = e.dataItem;
  }

  onDblClick() {
    if (this.clickedRowItem) {
      if (this.mode === 'lookup') {
        this.onSelectSingle.emit(this.clickedRowItem);
      }
      else {
        this.onEdit(this.clickedRowItem);
      }
    }
  }

  onEdit(syncMap) {
    const modalRef = this.modalService.open(SyncMapSingleComponent);
    modalRef.componentInstance.syncMap = syncMap;
    modalRef.componentInstance.idOfSyncMap = syncMap.id;
    modalRef.componentInstance.onFormSaved.subscribe(() => {
      this.loadListData();
      modalRef.close();
    });
  }

  onCreate() {
    const modalRef = this.modalService.open(SyncMapSingleComponent);
    modalRef.componentInstance.onFormSaved.subscribe(() => {
      this.loadListData();
      modalRef.close();
    });
  }

  get disableEditBtn() {
    return Object.keys(this.mySelection).length !== 1;
  }

  public gridFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.query = { PageNumber: 1, PageSize: this.query.PageSize, SortTerm: 'name', SearchTerm: '' };
    if (filter.filters.length > 0) {
      filter.filters.forEach((value) => {
        const myFilter: FilterDescriptor = value as FilterDescriptor;
        let tempName: string | undefined;
        if (typeof myFilter.field === 'string') {
          tempName = myFilter.field.includes('.') ? myFilter.field.split('.')[0] : myFilter.field;
        }
        const filterField = 'Filter_' + tempName;
        const operandField = 'Operand_' + tempName;
        const params = { ...this.query, [filterField]: myFilter.value, [operandField]: myFilter.operator };
        this.query = params;
      });
    }
    this.onFilterChange();
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.query.PageNumber = event.skip / event.take + 1;
    this.loadListData();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    let sortName = sort[0].field.includes('.') ? sort[0].field.split('.')[0] : sort[0].field;
    console.log(sortName);
    if (sort[0].dir == 'asc') {
      this.query.SortTerm = sortName
    } else if (sort[0].dir == 'desc') {
      this.query.SortTerm = '-' + sortName;
    } else {
      this.query.SortTerm = sortName;
    }
    this.loadListData();
  }

  public async loadListData() {
    this.loading = true;
    //this.query.PageSize = StorageService.PageSize() ?? 50;  //PageSize is a culprit in ExpressionChangedAfterItHasBeenCheckedError
    try {
      const response: any = await this.syncMapsService.getList(this.query);
      this.syncMaps = response.body;
      this.pagination = getPaginationHeader(response.headers);
      this.gridView = {
        data: this.syncMaps,
        total: this.pagination.TotalCount,
      };
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }
  edit(id: number) {
    this.router.navigate([`/price/sync-map/${id}`]);
  }

  async showRemovePopUp(content) {
    const result = await this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
    }).result;
  }

  async remove(modal) {
    const ids = [];
    this.mySelection.forEach((value) => {
      ids.push(Number(value));
    });
    await this.syncMapsService
      .removeByIds(ids)
      .then((showSuccess: VoidFunction) => {
        this.snack.openSnackBar(
          'Record(s) deleted successfully!',
          '',
          false,
          'Success',
          'alert-success',
        );
        this.mySelection = [];
      })
      .catch((err: HttpErrorResponse) => {
        this.snack.openSnackBar(err.error, '', true, 'Error', 'alert-danger');
      });

    modal.close();
    this.loadListData();
  }
  get disableDeleteBtn() {
    return !Object.keys(this.mySelection).length;
  }

  onSelectSingleItem(item) {
    this.onSelectSingle.emit(item);
  }

  onClick_RunNow(event: any): void {
    const index = event.id;
    if (index !== -1) {
      this.runNowMenuItemSelect(index);
    } else {
      console.error('Item not found in runNowMenuItems:', event);
    }
  }

  async runNowMenuItemSelect(selectedMenuItem): Promise<void> {
    for (const value of this.mySelection) {
      try {
        const params = [
          {
            Name: "@SyncMapID",
            Value: Number(value)
          },
          {
            Name: "@MenuOption",
            Value: Number(selectedMenuItem)
          }
        ];
        const paramList = JSON.stringify(params);
        const response: any = await this.utilitiesService.callStoredProc('usp_RPMUtilityCreateSyncQueueFromSyncMap', paramList);
        const status: any = response.status;
        if (status === 200) {
         
        }
      } catch (e) {
        this.snack.openSnackBar(e.error, '', true, 'Error', 'alert-danger');
        return;
      }
    }
    this.snack.openSnackBar(
      'Queues created successfully',
      '',
      false,
      'Success',
      'alert-success',
    );
  }

 
}
